'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ghostMenuGroups = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _blocks = require('../../blocks');

var _MenuGroupItem = require('./MenuGroupItem');

var _MenuGroupItem2 = _interopRequireDefault(_MenuGroupItem);

var _menuPropTypes = require('./menuPropTypes');

var _menuPropTypes2 = _interopRequireDefault(_menuPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ghostMenuGroups = exports.ghostMenuGroups = function ghostMenuGroups() {
  return [4, 2, 1].reduce(function (acc, val) {
    var currentGhostGroup = Array.from(new Array(val), function (v, idx) {
      return {
        // path is used as a key later on, so a unique value must
        // be provided here.
        path: val + ':' + idx,
        loading: true
      };
    });
    return acc.concat([currentGhostGroup]);
  }, []);
};

function MenuGroupsList(_ref) {
  var TextRenderer = _ref.TextRenderer,
      expanded = _ref.expanded,
      expandedMenus = _ref.expandedMenus,
      handleExpandMenuClick = _ref.handleExpandMenuClick,
      location = _ref.location,
      menuGroups = _ref.menuGroups,
      menuGroupsLoading = _ref.menuGroupsLoading;

  var renderedMenuGroups = menuGroupsLoading ? ghostMenuGroups() : menuGroups;

  return _react2.default.createElement(
    _blocks.LeftNav.MenuGroupsList,
    null,
    renderedMenuGroups.map(function (menuGroup, index) {
      var last = renderedMenuGroups.length - 1 === index;
      return _react2.default.createElement(_MenuGroupItem2.default
      // eslint-disable-next-line react/no-array-index-key
      , { key: index,
        TextRenderer: TextRenderer,
        expanded: expanded,
        expandedMenus: expandedMenus,
        handleExpandMenuClick: handleExpandMenuClick,
        last: last,
        location: location,
        menuGroup: menuGroup,
        menuGroupsLoading: menuGroupsLoading
      });
    })
  );
}

MenuGroupsList.propTypes = {
  TextRenderer: _propTypes2.default.func.isRequired,
  expanded: _propTypes2.default.bool.isRequired,
  expandedMenus: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  handleExpandMenuClick: _propTypes2.default.func.isRequired,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  // eslint-disable-next-line react/no-typos
  menuGroups: _menuPropTypes2.default.menuGroups.isRequired,
  menuGroupsLoading: _propTypes2.default.bool.isRequired
};

exports.default = MenuGroupsList;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/LeftNav/MenuGroupsList.js
// module id = 1670
// module chunks = 2